import styled, { keyframes, css } from 'styled-components';
import { COLORS, FONTS } from './../../ui';
import { Icon } from './../Icon';

interface Props {
  width?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  primary?: boolean;
  iconPos?: string;
}

const POSITION = {
  left: 'row',
  right: 'row-reverse'
};

const animationLoading = keyframes`
  to {transform: rotate(360deg);}
`;

export const ButtonIcon = styled(Icon)`
  margin: 0 5px;
`;

export const Loading = styled.div`
  display: inline-block;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${COLORS.BLACK};
  border-top: 2px solid ${COLORS.LIGHT_GRAY};
  animation: ${animationLoading} .6s linear infinite;

  ${(props: Props) => props.primary && css`
    border: 2px solid ${COLORS.WHITE};
    border-top: 2px solid ${COLORS.BLACK};
  `};
`;

export const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props: Props) => POSITION[props.iconPos]};
  width: ${(props: Props) => props.fullWidth ? '100%' : props.width};
  background-color: ${COLORS.LIGHT_GRAY};
  min-height: 40px;
  padding: 0 25px;
  border: none;
  border: 1px solid ${COLORS.OPAQUE_GRAY};
  border-radius: 4px;
  color: ${COLORS.BLACK};
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.HOVER_GRAY};
  }

  ${(props: Props) => props.disabled && css`
    pointer-events: none;
    user-select: none;
    opacity: 0.3;
  `};

  ${(props: Props) => props.loading && css`
    pointer-events: none;
    user-select: none;
  `};

  ${(props: Props) => props.primary && css`
    background:${COLORS.BLACK};
    color: ${COLORS.WHITE};

    &:hover {
      background-color: ${COLORS.HOVER_BLACK};
    }
  `};

  ${ButtonIcon} {
    svg {
      color: ${(props: Props) => props.primary 
        ? `${COLORS.WHITE}` 
        : `${COLORS.BLACK}`
      };
    }
  }
`;

Loading.displayName = 'Loading';
Wrapper.displayName = 'Wrapper';
ButtonIcon.displayName = 'ButtonIcon';